export const CONSENT_COOKIE = "sd_cookie_consent";
export const CONSENT_MAX_AGE_DAYS = 365;

export const CATEGORY_IDS = ["necessary", "preferences", "statistics", "marketing"];

export function defaultCategories(allowAll = false) {
  return {
    necessary: true,
    preferences: allowAll,
    statistics: allowAll,
    marketing: allowAll,
  };
}

export function generateConsentId() {
  const bytes = new Uint8Array(32);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value, maxAgeDays) {
  const maxAge = maxAgeDays * 24 * 60 * 60;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

export function deleteConsentCookie() {
  if (typeof document === "undefined") return;
  document.cookie = `${CONSENT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}

/** @returns {null | { id: string, date: string, state: string, categories: Record<string, boolean> }} */
export function readConsent() {
  const raw = readCookie(CONSENT_COOKIE);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !parsed.id) return null;
    return {
      id: String(parsed.id),
      date: String(parsed.date || ""),
      state: String(parsed.state || "custom"),
      categories: { ...defaultCategories(false), ...(parsed.categories || {}) },
    };
  } catch {
    return null;
  }
}

export function saveConsent({ state, categories }) {
  const record = {
    id: generateConsentId(),
    date: new Date().toISOString(),
    state,
    categories: { ...defaultCategories(false), ...categories, necessary: true },
  };
  writeCookie(CONSENT_COOKIE, JSON.stringify(record), CONSENT_MAX_AGE_DAYS);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("sd-cookie-consent", { detail: record }));
  }
  return record;
}

export function consentStateLabel(state, t) {
  const labels = t?.cookieConsent?.states || {};
  if (state === "allow_all") return labels.allow_all || "Allow all";
  if (state === "deny_all") return labels.deny_all || "Deny all";
  return labels.custom || "Custom";
}
